import { render, staticRenderFns } from "./StcvL.vue?vue&type=template&id=1b8afaf3"
import script from "./StcvL.vue?vue&type=script&lang=js"
export * from "./StcvL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports